export default class Sidebar {
    constructor() {
        const sidebarLabel =
            document.getElementsByClassName("c-sidebar__label")[0];
        const sidebar = document.getElementsByClassName("c-sidebar")[0];
        const sidebarClose = document.getElementsByClassName(
            "c-sidebar__content--close"
        )[0];
        const sidebarIcon =
            document.getElementsByClassName("c-sidebar__icon")[0];
        const mobile = window.matchMedia("(max-width: 768px)");

        if (sidebarClose) {
            sidebarClose.addEventListener("click", () => {
                sidebar.classList.toggle("c-sidebar--open");
            });
        }

        if (sidebarLabel) {
            sidebarLabel.addEventListener("click", () => {
                sidebar.classList.toggle("c-sidebar--open");
            });
        }

        function mobileMatch()  {
            if (mobile.matches) {
                window.addEventListener("scroll", () => {
                    var scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop ||
                    0;
                    var threshold = 125;
                    if (scrollTop > threshold) {
                        sidebar.style.display = "none";
                    } else {
                        sidebar.style.display = "block";
                    }
                });
            }
        };
        
        if (sidebar) {
            sidebar.addEventListener("onload", mobileMatch());
        }
    }
}
